
import { useLanguage } from '../contexts/LanguageContext'

function ServicesPageContent(){
    const { language } = useLanguage()
    
    if (language === 'eng') {
        return <>
            <h4>Skills</h4>
            <ol>
                <li>Domain registration and connection (website address on the internet).</li>
                <li>Email setup for the domain</li>
                <li>Installation of a content management system</li>
                <li>Installation of a design template for the content management system</li>
                <li>Connection of contact forms, lead collection forms</li>
                <li>Connection of payment processing, testing of payment gateway</li>
                <li>Placement of main information on the website (contact details and more)</li>
            </ol>
        </>
    }
    
    // Russian version
    return <>
        <h4>Навыки</h4>
        <ol>
            <li>Регистрация и подключение домена (адрес сайта в интернете).</li>
            <li>Настройка почты для домена</li>
            <li>Установка системы управления сайтом</li>
            <li>Установка шаблона оформления для системы управления сайтом</li>
            <li>Подключение формы для обратной связи, сбора заявок</li>
            <li>Подключение приема платежей, тестирование приема оплаты эквайринг</li>
            <li>Размещение основной информации на сайте (контактные данные и прочее)</li>
        </ol>
    </>
}

export default ServicesPageContent